import gql from "graphql-tag";
import { ventureFragment } from "./fragments";

export const saveVenture = gql`
  mutation saveVenture(
    $data: VentureUpdateInput!
    $where: VentureWhereUniqueInput
  ) {
    saveVenture(data: $data, where: $where) {
      id
    }
  }
`;

export const saveVentureWithAI = gql`
  mutation saveVentureWithAI(
    $userId: String!
    $llmData: Json!
    $ventureData: Json!
  ) {
    saveVentureWithAI(
      userId: $userId
      llmData: $llmData
      ventureData: $ventureData
    ) {
      id
      targetCustomerUsers {
        id
      }
    }
  }
`;

export const saveTargetCustomerUser = gql`
  mutation saveTargetCustomerUser(
    $data: TargetCustomerUserUpdateInput!
    $where: TargetCustomerUserWhereUniqueInput!
  ) {
    saveTargetCustomerUser(data: $data, where: $where) {
      id
      interviewRewardAmount
      interviewRewardMax
      interviewBudget
      surveyRewardAmount
      surveyRewardMax
      surveyBudget
      contacts {
        id
        user {
          id
          firstName
          lastName
          email
          phones {
            id
            number
          }
          emails {
            id
            address
          }
          socialHandles {
            id
            handle
            platform
          }
        }
      }
    }
  }
`;

export const saveVentureContact = gql`
  mutation saveVentureContact(
    $ventureId: String!
    $targetCustomerUserId: String!
    $contacts: Json!
  ) {
    saveVentureContact(
      ventureId: $ventureId
      targetCustomerUserId: $targetCustomerUserId
      contacts: $contacts
    )
  }
`;

export const buildVentureSurvey = gql`
  mutation buildVentureSurvey(
    $ventureId: String!
    $targetCustomerUserId: String!
    $opportunities: Json
  ) {
    buildVentureSurvey(
      ventureId: $ventureId
      targetCustomerUserId: $targetCustomerUserId
      opportunities: $opportunities
    )
  }
`;

export const saveVentureResearchPath = gql`
  mutation saveVentureResearchPath(
    $interviews: Boolean!
    $surveys: Boolean!
    $targetCustomerUser: Json!
    $ventureId: String!
    $userId: String!
    $creatorEmail: String!
  ) {
    saveVentureResearchPath(
      interviews: $interviews
      surveys: $surveys
      targetCustomerUser: $targetCustomerUser
      ventureId: $ventureId
      userId: $userId
      creatorEmail: $creatorEmail
    )
  }
`;

export const purgeVenture = gql`
  mutation purgeVenture($ventureId: String!) {
    purgeVenture(ventureId: $ventureId)
  }
`;

export const addVentureTo = gql`
  mutation addVentureTo(
    $cohortId: String
    $userId: String!
    $ventureId: String!
    $ecosystemId: String
  ) {
    addVentureTo(
      cohortId: $cohortId
      userId: $userId
      ventureId: $ventureId
      ecosystemId: $ecosystemId
    )
  }
`;

export const removeVentureFrom = gql`
  mutation removeVentureFrom(
    $cohortId: String
    $userId: String!
    $ventureId: String!
    $ecosystemId: String
  ) {
    removeVentureFrom(
      cohortId: $cohortId
      userId: $userId
      ventureId: $ventureId
      ecosystemId: $ecosystemId
    )
  }
`;
